import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { nftAssetSeriesDrawerAtom } from "../../stores/main";

export const NftShortcut = () => {
  const { t } = useTranslation()
  const navi = useNavigate()
  const setDraw = useSetRecoilState(nftAssetSeriesDrawerAtom)
  return (
    <>
      <Button variant="outline-success" className="mr-3" onClick={() => {
        navi('/web/home')
      }}>{t('exploreNft')}</Button>
      <Button variant="outline-success" className="mr-3" onClick={() => {
        setDraw(true);
      }}>系列管理</Button>
      <Button variant="outline-success" onClick={() => {
        navi('/web/mint')
      }}>{t('mintNft')}</Button>
    </>
  )
}